import { render } from "./ChooseGiftType.vue?vue&type=template&id=4963f5b1&scoped=true"
import script from "./ChooseGiftType.vue?vue&type=script&lang=js"
export * from "./ChooseGiftType.vue?vue&type=script&lang=js"

import "./ChooseGiftType.vue?vue&type=style&index=0&id=4963f5b1&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4963f5b1"]])

export default __exports__